import {DataFetcher} from '@aboutyou/data-fetcher';
import {DiscountCardInformationSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/discount_card_information_section.types';
import React from 'react';
import {useDiscountCardInformationSection} from '../../hooks/useGetBasketPageSection';
import {BasketTotalDiscountCardView} from './BasketTotalDiscountCardView';

export const BasketTotalDiscountCard: React.FC<
  DiscountCardInformationSection
> = props => {
  return (
    <DataFetcher
      /**
       * As we use this component as a child of a datafetcher which already fetches
       * this section, we can just use it here and can also disable the
       * request as the data is already available
       * Disclaimer: Do not copy this pattern over to new component achitectures
       */
      request={useDiscountCardInformationSection({disabled: true})}
      Error={() => null}
      View={BasketTotalDiscountCardView}
      viewProps={props}
    />
  );
};
